export default __webpack_public_path__ + "static/media/icon-signature.c12dec90.svg";